/**
 * Essai bridge — optional auto-redirect on homepage only (graceful; CTAs remain primary).
 */
(function () {
  function run() {
    var cfg = window.bridgeTheme;
    if (!cfg || !cfg.redirectUrl) return;
    var delay = Number(cfg.redirectDelayMs);
    if (!delay || delay < 0) return;
    if (!document.body || !document.body.classList.contains("template-index")) return;

    window.setTimeout(function () {
      window.location.assign(cfg.redirectUrl);
    }, delay);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
